/**
 * Cart Variant Selector
 * Handles variant selection and quantity changes in cart
 */

document.addEventListener('DOMContentLoaded', function () {
  const cart = {
    init: function () {
      console.log('=== CART MANAGER INIT ===');
      this.delegateEvents();
    },

    delegateEvents: function () {
      // Variant button clicks
      document.addEventListener('click', (e) => {
        const btn = e.target.closest('.cart-variant-option');
        if (btn) {
          console.log('Variant button clicked:', btn);
          e.preventDefault();
          this.changeVariant(e);
        }
      });

      // Quantity input changes
      document.addEventListener('change', (e) => {
        if (e.target.matches('.qty-input')) {
          this.changeQuantity(e);
        }
      });

      // Quantity +/- buttons
      document.addEventListener('click', (e) => {
        const btn = e.target.closest('.qty-btn');
        if (btn) {
          e.preventDefault();
          this.handleQtyButton(btn);
        }
      });

      // Remove item link
      document.addEventListener('click', (e) => {
        if (e.target.closest('.cart-item-remove')) {
          e.preventDefault();
          const link = e.target.closest('.cart-item-remove');
          this.removeItem(link);
        }
      });
    },

    changeVariant: function (event) {
      const button = event.target.closest('.cart-variant-option');
      if (!button) {
        console.error('No button found');
        return;
      }

      const variantId = parseInt(button.getAttribute('data-variant-id'));
      const cartItem = button.closest('.cart-item-card');
      const itemKey = cartItem.getAttribute('data-cart-item');
      const qtyInput = cartItem.querySelector('.qty-input');
      const quantity = parseInt(qtyInput.value) || 1;

      console.log('=== VARIANT CHANGE ===');
      console.log('Variant ID:', variantId);
      console.log('Quantity:', quantity);
      console.log('Item Key:', itemKey);

      if (!variantId) {
        console.error('Missing variant ID');
        return;
      }

      //   button.disabled = true;
      const origText = button.textContent;
      button.textContent = '...';

      // Get line number from cart
      fetch('/cart.js')
        .then(r => r.json())
        .then(cartData => {
          let lineNum = null;
          for (let i = 0; i < cartData.items.length; i++) {
            if (cartData.items[i].key === itemKey) {
              lineNum = i + 1;
              console.log('✓ Found line number:', lineNum);
              break;
            }
          }
          if (!lineNum) {
            console.error('✗ Item not found in cart');
            throw new Error('Item not found');
          }

          // First remove the old item using /cart/change.js
          console.log('Removing old item from line:', lineNum);

          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              line: lineNum,
              quantity: 0
            })
          });
        })
        .then(r => {
          console.log('Remove response status:', r.status);
          if (!r.ok) {
            return r.text().then(text => {
              console.error('✗ Error removing item:', text);
              throw new Error(`HTTP ${r.status}: ${text}`);
            });
          }
          return r.json();
        })
        .then(cartData => {
          console.log('✓ Old item removed, cart now has', cartData.items.length, 'items');

          // Now add new item with new variant
          console.log('Adding new item with variant:', variantId, 'quantity:', quantity);

          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: variantId,
                quantity: quantity
              }]
            })
          });
        })
        .then(r => {
          console.log('Add response status:', r.status);
          if (!r.ok) {
            return r.text().then(text => {
              console.error('✗ Error adding new item:', text);
              throw new Error(`HTTP ${r.status}: ${text}`);
            });
          }
          return r.json();
        })
        .then(cartData => {
          console.log('✓ Variant changed!');
          console.log('New cart:', cartData);

          // Find new item in cart
          const updatedItem = cartData.items.find(item => item.variant_id === variantId);
          if (updatedItem) {
            console.log('Updated item:', updatedItem);

            // Update variant name if it exists
            const variantNameEl = cartItem.querySelector('.cart-item-variant');
            if (variantNameEl && updatedItem.variant_title) {
              variantNameEl.textContent = updatedItem.variant_title;
              console.log('✓ Updated variant name to:', updatedItem.variant_title);
            }

            // Update prices
            const priceEl = cartItem.querySelector('.cart-item-final-price');
            const originalPriceEl = cartItem.querySelector('.cart-item-original-price');

            if (priceEl) {
              const formattedPrice = this.formatMoney(updatedItem.final_price);
              priceEl.textContent = formattedPrice;
              console.log('✓ Updated final price to:', formattedPrice);
            }

            // If there's a discount, update the original price too
            if (originalPriceEl && updatedItem.original_price !== updatedItem.final_price) {
              const formattedOriginal = this.formatMoney(updatedItem.original_price);
              originalPriceEl.textContent = formattedOriginal;
              console.log('✓ Updated original price to:', formattedOriginal);
            } else if (originalPriceEl && updatedItem.original_price === updatedItem.final_price) {
              // No discount, hide the original price
              originalPriceEl.style.display = 'none';
            }

            // Update cart item key attribute for future updates
            cartItem.setAttribute('data-cart-item', updatedItem.key);
          }

          // Update button styling
          const allButtons = cartItem.querySelectorAll('.cart-variant-option');
          allButtons.forEach(btn => {
            btn.classList.remove('selected');
            if (parseInt(btn.getAttribute('data-variant-id')) === variantId) {
              btn.classList.add('selected');
            }
          });

          // Update cart totals in sidebar
          this.updateCartTotals(cartData);

          button.disabled = false;
          button.textContent = origText;
        })
        .catch(err => {
          console.error('✗ Error:', err.message);
          button.disabled = false;
          button.textContent = origText;
        });
    },

    changeQuantity: function (event) {
      const input = event.target;
      const cartItem = input.closest('.cart-item-card');
      const itemKey = cartItem.getAttribute('data-cart-item');
      let quantity = parseInt(input.value);

      console.log('=== QUANTITY CHANGE ===');
      console.log('Item key:', itemKey);
      console.log('New quantity:', quantity);

      if (quantity < 1) {
        input.value = 1;
        return;
      }

      const self = this;
      const bundleIdOf = function (it) {
        return it.properties && (it.properties._TRIKOT || it.properties._bundle_id);
      };

      fetch('/cart.js')
        .then(r => r.json())
        .then(cartData => {
          const idx = cartData.items.findIndex(it => it.key === itemKey);
          if (idx < 0) throw new Error('Item not found');
          const item = cartData.items[idx];
          const bundleId = bundleIdOf(item);
          const isMain = item.properties && item.properties._bundle_type === 'main';

          // Bundle main line: scale the whole bundle all-or-nothing — if any line
          // can't reach the new qty, revert all so it's never left inconsistent
          if (bundleId && isMain) {
            const bundleItems = cartData.items.filter(it => bundleIdOf(it) === bundleId);
            let prevQty = 0;
            bundleItems.forEach(it => { if (it.quantity > prevQty) prevQty = it.quantity; });
            const postAll = function (q) {
              const updates = {};
              bundleItems.forEach(it => { updates[it.key] = q; });
              return fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates: updates })
              }).then(r => r.json());
            };
            return postAll(quantity).then(updated => {
              if (quantity <= prevQty) return updated; // reductions stay consistent
              const after = updated.items.filter(it => bundleIdOf(it) === bundleId);
              const allReached =
                after.length === bundleItems.length &&
                after.every(it => it.quantity === quantity);
              if (allReached) return updated;
              return postAll(prevQty); // partial failure → revert entire bundle
            });
          }

          // Regular line: single change.
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: idx + 1, quantity: quantity })
          }).then(r => {
            if (!r.ok) {
              // Shopify REFUSES an over-availability change with a 422 rather than
              // clamping ("Aufgrund der Verfügbarkeit wurden nur X Artikel …").
              // Treating that as a hard error reloaded the whole page — the silent
              // "snap back". Refetch the real cart instead and fall through to the
              // normal update path, which resets the input and shows the capped note.
              if (r.status === 422) {
                return fetch('/cart.js').then(rr => rr.json());
              }
              return r.text().then(text => { throw new Error(text); });
            }
            return r.json();
          });
        })
        .then(cartData => {
          const updatedItem = cartData.items.find(item => item.key === itemKey);
          if (!updatedItem) {
            // Bundle line was removed / re-keyed — reload to re-render cleanly.
            location.reload();
            return;
          }
          input.value = updatedItem.quantity;
          if (quantity > updatedItem.quantity) {
            self.showCappedNote(cartItem, updatedItem.quantity);
          }
          const totalPriceEl = cartItem.querySelector('.cart-item-total-price');
          if (totalPriceEl) {
            totalPriceEl.textContent = self.formatMoney(updatedItem.final_line_price);
          }
          self.updateCartTotals(cartData);
          // Let the bundle collapser recompute the bundle total + breakdown.
          document.dispatchEvent(new CustomEvent('cart:updated'));
        })
        .catch(err => {
          console.error('Quantity change error:', err);
          location.reload();
        });
    },

    // The shop granted less than asked (inventory / preorder cap) and the input snapped
    // back — say why instead of leaving the snap unexplained. Self-removing.
    showCappedNote: function (cartItem, grantedQuantity) {
      if (typeof quantityCappedMessage === 'undefined' || !quantityCappedMessage) return;
      const controls = cartItem.querySelector('.cart-quantity-controls');
      if (!controls) return;
      const existing = controls.parentElement.querySelector('.cart-qty-capped-note');
      if (existing) existing.remove();
      const note = document.createElement('p');
      note.className = 'cart-qty-capped-note';
      note.setAttribute('role', 'status');
      note.textContent = quantityCappedMessage.replace('[qty]', String(grantedQuantity));
      controls.insertAdjacentElement('afterend', note);
      setTimeout(() => { note.remove(); }, 5000);
    },

    handleQtyButton: function (button) {
      const cartItem = button.closest('.cart-item-card');
      const input = cartItem.querySelector('.qty-input');
      let quantity = parseInt(input.value) || 1;

      if (button.getAttribute('data-action') === 'increase') {
        quantity++;
      } else if (button.getAttribute('data-action') === 'decrease') {
        quantity--;
      }

      if (quantity < 1) quantity = 1;
      input.value = quantity;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    },

    removeItem: function (link) {
      const cartItem = link.closest('.cart-item-card');
      const itemKey = cartItem.getAttribute('data-cart-item');

      console.log('=== REMOVE ITEM ===');
      console.log('Item key:', itemKey);

      const bundleIdOf = function (it) {
        return it.properties && (it.properties._TRIKOT || it.properties._bundle_id);
      };

      fetch('/cart.js')
        .then(r => r.json())
        .then(cartData => {
          const idx = cartData.items.findIndex(it => it.key === itemKey);
          if (idx < 0) throw new Error('Item not found');
          const item = cartData.items[idx];
          const bundleId = bundleIdOf(item);
          const isMain = item.properties && item.properties._bundle_type === 'main';

          // Removing a configured jersey removes its whole bundle (add-ons too).
          if (bundleId && isMain) {
            const updates = {};
            cartData.items.forEach(it => {
              if (bundleIdOf(it) === bundleId) updates[it.key] = 0;
            });
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: updates })
            }).then(r => r.json());
          }

          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: idx + 1, quantity: 0 })
          }).then(r => {
            if (!r.ok) return r.text().then(text => { throw new Error(text); });
            return r.json();
          });
        })
        .then(cartData => {
          // Fade out and remove the cart item from DOM
          cartItem.style.transition = 'opacity 0.3s ease-out';
          cartItem.style.opacity = '0';

          setTimeout(() => {
            cartItem.remove();
            console.log('Cart item removed from DOM');

            // Update cart totals in sidebar
            this.updateCartTotals(cartData);
            // Check if cart is empty
            const cartItems = document.querySelectorAll('.cart-item-card');
            if (cartItems.length === 0) {
              console.log('Cart is now empty');
              document.querySelector('.continue-shopping').classList.remove('hidden');
              document.querySelector('.cart-items').classList.add('hidden');
            }
          }, 300);
        })
        .catch(err => {
          console.error('✗ Remove item error:', err);
          alert('Failed to remove item');
        });
    },

    updateCartTotals: function (cartData) {
      console.log('=== FETCHING UPDATED CART SIDEBAR ===');

      // Fetch the updated cart page to get fresh sidebar HTML with recalculated totals
      fetch(window.location.href)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const newDoc = parser.parseFromString(html, 'text/html');

          // Get the new sidebar from the fetched HTML
          const newSidebar = newDoc.querySelector('.cart-sidebar');
          const oldSidebar = document.querySelector('.cart-sidebar');

          if (newSidebar && oldSidebar) {
            console.log('✓ Replacing sidebar with fresh HTML');
            oldSidebar.replaceWith(newSidebar);
            console.log('✓ Sidebar re-rendered with updated totals');
          } else {
            console.warn('Could not find sidebar elements');
          }
        })
        .catch(error => {
          console.error('Error fetching cart sidebar:', error);
        });
    },

    formatMoney: function (cents) {
      if (!cents && cents !== 0) return '0.00';
      const dollars = cents / 100;

      // Try to get the shop currency from the page data, default to CHF
      let currency = 'CHF';
      if (window.Shopify && window.Shopify.currency) {
        currency = window.Shopify.currency.active || 'CHF';
      }

      const formatted = dollars.toLocaleString('de-CH', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      return currency + ' ' + formatted;
    }
  };

  cart.init();
  window.CartManager = cart;
});
